import { render, staticRenderFns } from "./GeneralSettingsDateFormatGlobal.vue?vue&type=template&id=9a8dc650&"
import script from "./GeneralSettingsDateFormatGlobal.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingsDateFormatGlobal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports